import React from "react";



const thStyle = {
    background: "#f8f9fa",
    color: "#495057",
    fontWeight: 600,
    fontSize: "13px",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    borderBottom: "2px solid #dee2e6"
};

const UserGrid = ({

    users,

    loading,
     onOpen

}) => {

    return (

        <div className="card shadow-sm">

            <div className="table-responsive">

                <table className="table table-hover align-middle mb-0">

                    <thead>

                        <tr>

                            <th style={thStyle}>
                                Username
                            </th>

                            <th style={thStyle}>
                                Email
                            </th>

                            <th style={thStyle}>
                                Role
                            </th>
                            <th style={thStyle}>
                                Tenant
                            </th>

                            <th style={thStyle}>
                                Department
                            </th>

                            <th style={thStyle}>
                                Location
                            </th>

                            <th
                                style={thStyle}
                                className="text-center"
                            >
                                Custom Access
                            </th>

                            <th style={thStyle}>
                                Status
                            </th>

                            <th
                                style={thStyle}
                                className="text-center"
                                width="140"
                            >
                                Action
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            loading &&

                            <tr>

                                <td
                                    colSpan="8"
                                    className="text-center py-4"
                                >

                                    Loading...

                                </td>

                            </tr>

                            }

                            {

                                !loading &&
                                users.length === 0 &&

                                <tr>

                                    <td
                                        colSpan="8"
                                        className="text-center py-4"
                                    >

                                        No users found

                                    </td>

                                </tr>

                                }
                        {

                            users.map(user => (

                                <tr key={user.user_access_mapping_id}>

                                    <td>
                                        {user.username}
                                    </td>

                                    <td>
                                        {user.email}
                                    </td>

                                    <td>
                                        {user.role_name}
                                    </td>
                                    <td>
                                        {user.tenant_name || "-"}
                                    </td>
                                    <td>
                                        {user.department_name || "-"}
                                    </td>

                                    <td>
                                        {user.location_name || "-"}
                                    </td>

                                    <td className="text-center">

                                        {

                                            0 > 0 ?

                                                <span className="badge bg-warning text-dark">

                                                    0

                                                </span>

                                                :

                                                <span className="badge bg-secondary">

                                                    None

                                                </span>

                                        }

                                    </td>

                                    <td>

                                    <span
                                        className={`badge ${
                                            user.is_active
                                                ? "bg-success"
                                                : "bg-danger"
                                        }`}
                                    >

                                        {user.is_active ? "Active" : "Inactive"}

                                    </span>

                                </td>

                                    <td className="text-center">

                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => onOpen(user)}
                                        >

                                            🔐 Security

                                        </button>
                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

};

export default UserGrid;